/**
 *
 * Summary
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
// import _get from 'lodash/get';
import _has from 'lodash/has';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import ContentBlock from 'components/ContentBlock';
import { CONTENT_BLOCK_POSITIONS } from 'components/ContentBlock/utils';
import useSiteCopySelector from 'components/useSiteCopySelector';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { getScoreComponentItemId } from '../utils';

const useStyles = makeStyles(theme => ({
  container: {
    marginTop: 16,
    marginBottom: 16,
  },
  blocksContainer: {
    marginTop: 20,
  },
  block: {
    backgroundColor: '#F8F9F9',
    borderLeftWidth: 5,
    borderLeftStyle: 'solid',
  },
  blockTitleWrapper: {
    padding: '19px 29px',
    [theme.breakpoints.down('xs')]: {
      padding: 12,
    },
  },
  blockTextWrapper: {
    padding: '19px 0',
    [theme.breakpoints.down('xs')]: {
      padding: 12,
    },
  },
  link: {
    ...theme.typography.overline,
    color: '#01619B',
    cursor: 'pointer',
    paddingRight: 8,
  },
}));

function Summary({ overall, components, options, id }) {
  const classes = useStyles();
  const [assessmentResultsSiteCopy] = useSiteCopySelector([
    'assessment-results',
  ]);

  const filteredComponents = [overall, ...components].filter(
    component => component != null,
  );

  if (_has(options, 'sortOrder') && !_isEmpty(options.sortOrder)) {
    if (options.sortOrder === 'highestToLowest')
      filteredComponents.sort(sortDescending);
    else if (options.sortOrder === 'lowestToHighest')
      filteredComponents.sort(sortAscending);
  }

  const subHeader = _get(options, 'summarySubHeader');
  const config = _get(options, 'summaryConfig');
  if (!config) return null;

  const handleClick = e => {
    const $anchor = document.getElementById(
      getScoreComponentItemId(e.target.id),
    );
    if ($anchor) {
      const offsetTop =
        $anchor.getBoundingClientRect().top + window.pageYOffset;
      window.scroll({
        top: offsetTop - 180,
        behavior: 'smooth',
      });
    }
  };

  return (
    <Grid item xs={12} className={classes.container} id="summary-container">
      <Typography variant="h5" align="center" gutterBottom>
        {_get(assessmentResultsSiteCopy, 'pageCopy.summaryHeader')}
      </Typography>
      <ContentBlock
        type="assessment-results"
        position={CONTENT_BLOCK_POSITIONS.ASSESSMENT_RESULTS}
        index={1}
        id={id}
      />
      {subHeader && (
        <Typography variant="body2" align="center">
          {subHeader}
        </Typography>
      )}
      <Grid container spacing={1} className={classes.blocksContainer}>
        {config.map(section => {
          const sectionItems = filteredComponents.filter(
            ({ scoring, summaryId }) =>
              scoring !== -1 && section.id === summaryId,
          );

          if (sectionItems.length === 0) return null;

          return (
            <Grid item xs={12}>
              <Grid
                container
                className={classes.block}
                style={{ borderColor: section.color }}
              >
                <Grid item xs={12} sm={3} className={classes.blockTitleWrapper}>
                  <Typography variant="h6">{section.title}</Typography>
                </Grid>
                <Grid item xs={12} sm={9} className={classes.blockTextWrapper}>
                  <Grid container spacing={1}>
                    {sectionItems.map(item => (
                      <Grid item xs={6} sm={4} key={`summary-${item.name}`}>
                        <Typography
                          id={item.labelValue}
                          onClick={handleClick}
                          className={classes.link}
                        >
                          {item.name}
                        </Typography>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
}

Summary.propTypes = {
  components: PropTypes.array,
  overall: PropTypes.object,
  options: PropTypes.object,
  id: PropTypes.string,
};

export default Summary;

function sortAscending(a, b) {
  return a.scoring - b.scoring;
}

function sortDescending(a, b) {
  return b.scoring - a.scoring;
}
